import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Form, Image, Row } from "react-bootstrap";
import Cart from "../Cart/Cart";
import "./Verify.scss";
import { config } from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { CartData } from "../../interfaces/CartData";
import { useCart } from "../../services/cartService";
import { useHeaderMenu, writeLoginSession } from "../../contexts/login.context";
import Spinner from "../Spinner/Spinner";
import useLoader from "../../contexts/LoaderContext";
import cartLoader from '../../assets/images/cart_Loader.gif';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from "react-i18next";
import DOMPurify from 'dompurify';
import { sanitizePhoneNo, formatPhoneNoInReadableForm, isJwtTokenExpired, resolveCompanyNameFromCart } from '../../helpers/common';
import { configureRecaptchaForLocale } from '../../helpers/recaptchaConfig';
import { useLocalization } from '../../contexts/LocalizationContext';
import { LOCALES_WITHOUT_NVSTORE_PAYMENT_CONFIG } from '../../constants/localesWithoutNvstorePaymentConfig';
import ErrorModal from "../ErrorModal/ErrorModal";
import { jwtDecode } from "jwt-decode";
import { initialize } from "@nv-ces/ucp-wrapper";
import { v4 as uuidv4 } from "uuid";
import { useGuestAccessToken } from "../../hooks/useGuestAccessToken";
import { buildUcpOptions, getUcpEnvironment } from "../../services/ucpOptions";
import { isRegisteredCheckout } from "../../helpers/checkoutAuth";


const COUNTRY_CODE_JP = 'JP';
const COUNTRY_CODE_LOCAL_JP = '日本';
const COUNTRY_CODE_TW = 'TW';
const COUNTRY_CODE_LOCAL_TW = '台灣';
const COUNTRY_CODE_ME = 'AE';
const COUNTRY_CODE_LOCAL_ME = 'UAE';
const Verify: React.FC = () => {
  const { state } = useLocation();
  const { locale, localeWith_, defaultCurrency } = useLocalization();
  configureRecaptchaForLocale(locale);
  const paymentConfigAttr = LOCALES_WITHOUT_NVSTORE_PAYMENT_CONFIG.includes(locale)
    ? {}
    : { 'payment-config': 'nvstore-standard-payments' as const };
  const userType =
    (typeof state?.user === 'string' && state.user) ||
    sessionStorage.getItem('userType') ||
    sessionStorage.getItem('customer');
  const validations = state ? state.validationErrors : '';
  const navigate = useNavigate();
  const isDownload: boolean = false;
  const isThanks: boolean = false;
  const isVerify: boolean = true;
  const { t } = useTranslation();
  const googleKey = config.captchaKey;
  const captchaRef = useRef<ReCAPTCHA | null>(null);
  const [cartData, setCartData] = useState<CartData>();
  const [billingInfoName, setbillingInfoName] = useState('');
  const [billingInfoEmail, setbillingInfoEmail] = useState('');
  const [billingAddress, setbillingAddress] = useState('');
  const [billingCountry, setbillingCountry] = useState('');
  const [billingContact, setbillingContact] = useState('');
  const [couponCode, setCoupon] = useState<string | null>(null);
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const [captchaScore, setCaptchaScore] = useState<number | undefined>(undefined);
  const { isLoading, showLoader, hideLoader, isCartLoading, hideCartLoader, showCartLoader, hideBodyLoader } = useLoader();
  const { setLoginStatus, setItemsInCart, setIsDownload, setCartCategory, deviceFingerprintUuid, setDeviceFingerprintUuid, cartCategory } = useHeaderMenu();
  const [validationErrors, setValidationErrors] = useState<Record<string, string>>(validations || {});
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errorCode, setErrorCode] = useState<null | string>(null);
  const [reCaptchaToken, setReCaptchaToken] = useState<string | null>(null);
  const { getCart, updateCart, submitOrder, submitCapatcha, getPaymentIntent, mintGuestAccessToken } = useCart();
  const isLoggedIn = isRegisteredCheckout(userType, cartData?.idt);
  const isGuest = !isLoggedIn;
  const guestEmail =
    cartData?.emailAddress?.trim() ||
    cartData?.billingAddress?.emailAddress?.trim() ||
    "";
  const {
    token: guestAccessToken,
    error: guestTokenError,
    handleUcpGlobalEvent,
  } = useGuestAccessToken({
    enabled: isGuest && Boolean(cartData),
    email: guestEmail,
    mintToken: mintGuestAccessToken,
  });
  const [guestUcpInitializationError, setGuestUcpInitializationError] =
    useState(false);
  const [guestUcpReady, setGuestUcpReady] = useState(false);
  const guestPaymentUnavailable =
    isGuest &&
    (guestTokenError ||
      guestUcpInitializationError ||
      !guestAccessToken ||
      !guestUcpReady);
  const [disclaimerText, setDisclaimerText] = useState<string | null>(null);
  const [sanitizedText, setSanitizedText] = useState<string | null>(null);
  const [showSubmitOrderErrorModal, setShowSubmitOrderErrorModal] = React.useState(false);
  const [paymentIntent, setPaymentIntent] = useState<string | null>(null);
  const [localLoader, setLocalLoader] = useState<boolean>(false);
  const [enablePlaceOrder, setEnablePlaceOrder] = useState<boolean>(() =>
    Boolean(deviceFingerprintUuid?.trim())
  );
  useEffect(() => {
    if (deviceFingerprintUuid?.trim()) {
      setEnablePlaceOrder(true);
    }
  }, [deviceFingerprintUuid]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentIntentId = urlParams.get('payment-intent-id');
    if (paymentIntentId) {
      setPaymentIntent(paymentIntentId);
    }
  }, []);

  useEffect(() => {
    if (disclaimerText) {
      let discTxt = DOMPurify.sanitize(disclaimerText, {
        ALLOWED_TAGS: ['a'], // Allow anchor tags
        ALLOWED_ATTR: ['href', 'target', 'rel', 'class'], // Allow necessary attributes including target
      });
      setSanitizedText(discTxt);
    }
  }, [isDownload, disclaimerText]);

  const handleCartChange = async() => {
    console.log('handleCartChange===>', userType);
    if (isLoggedIn && cartData?.idt) {
      const token = cartData?.idt;
      const decoded = jwtDecode(token);
      console.log('idToken decoded===>', decoded);
      const timestamp = decoded['updated_at']; // seconds
      const date = new Date(timestamp * 1000);
      const timestampISO = date.toISOString();
      const writeSession = await writeLoginSession(decoded['email'], decoded['idp_id'], timestampISO, decoded['sub'] || '');
      console.log('writeSession===>', writeSession);
      console.log('writeSession called');
      navigate(`/${locale}/software/cart/user/loggedIn`)
    } else {
      navigate(`/${locale}/software/cart/user/guest`)
    }
  }
  const captchaLanguage = locale.split('-')[0];

  useEffect(() => {
    if (isGuest) {
      if (captchaScore) {
        setIsDisable(false);
        console.log(isDisable);
      } else {
        setIsDisable(true);
        console.log(isDisable);
      }
    } else {
      setIsDisable(false);
      console.log(isDisable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captchaScore, isGuest])
  const resetRecaptcha = () => {
    if (captchaRef.current) {
      captchaRef.current.reset();
      setCaptchaScore(undefined);
    }
  };
  const handleCaptchaError = useCallback(() => {
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCaptchaSuccess = useCallback((result) => {
    if (result.valid && result.score > 0.4) {
      setCaptchaScore(result.score);
      console.log('handleCaptchaSuccess===>', result);
    } else {
      resetRecaptcha();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCaptchaTimeout = () => {
    resetRecaptcha();
  }
  const handleRecaptcha = async (token: string | null) => {
    setReCaptchaToken(token);
    // Send the token to your backend
    if (token) {
      let tokenObj = { "token": token, "siteKey": config.captchaKey, "expectedAction": "SUBMIT" }
      // Make an API request to your backend with the token
      // Example using fetch:
      await submitCapatcha(tokenObj, handleCaptchaSuccess, handleCaptchaError);
    }
  };
  const fieldNameRef = useRef<string | null>(null);
  const handleCouponDelete = (c: boolean = false) => {
    console.log('CouponDelete==>', c);
  }
  const handleCouponSubmit = (c: string) => {
    console.log('couponCode==>', couponCode, c);
    handleCartUpdate(undefined, undefined, c, false)
  }
  const handleCouponChange = (fieldName: string, promo: string) => {
    setCoupon(promo);
    fieldNameRef.current = fieldName;
  }
  const handleCouponError = () => {
    hideLoader();
  }
  const handleSuccess = useCallback((result) => {
    setCartData(result);
    setLoginStatus(Boolean(result?.idt));
    setItemsInCart(result.totalItemsInCart);
    setIsDownload(result.isDigital);
    setCartCategory(result.category?.toUpperCase() ?? '');
    hideLoader();
    hideCartLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleError = useCallback(() => {
    const emptyCart = (msg:string) => navigate(`/${locale}/software/cart/empty`, { state: { msg ,cartCategory: cartCategory as string } });
    hideCartLoader();
    emptyCart(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, locale]);
  const handleCartUpdate = async (productId?: string, selectedOption?: number, coupon?: string, couponApplied?: boolean) => {
    showCartLoader();
    if (productId && (selectedOption !== undefined && selectedOption !== null)) {
      await updateCart(handleSuccess, handleError, productId, selectedOption, isDownload, undefined, undefined, false);
    } else {
      if (coupon) {
        await updateCart(handleSuccess, handleCouponError, undefined, undefined, isDownload, coupon, undefined, false);
      } else {
        if (couponApplied) {
          await updateCart(handleSuccess, handleCouponError, undefined, undefined, isDownload, undefined, undefined, true);
        }
      }
    }
    hideCartLoader();
  };
  const thankyou = useCallback((cartResult) => {
    navigate(`/${locale}/software/cart/thankyou`, {
      state: { cartResult, isLoggedIn },
    });
  },
    [navigate, locale, isLoggedIn]
  );
  const handlePaymentIntentSuccess = (result) => {
    console.log('HANDLE PAYMENT INTENT SUCCESS===>', result);
    setPaymentIntent(result.payment_intent_id);
    if (result.payment_intent_id) {
      setPaymentIntent(result.payment_intent_id);
    } else {
      submitOrder(handleOrderSuccess, handleOrderError, true);
    }
    setLocalLoader(true);
    hideLoader();
  };


  const handleOrderSuccess = useCallback((result) => {
    console.log('HANDLE SUCCESS===>', result?.order?.orderState)
    sessionStorage.setItem('isPlaced', 'true');
    thankyou(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thankyou]);
  const handleOrderError = useCallback((error: any) => {
    setErrorCode(error?.code);
    setErrorMessage(error?.description);
    setCaptchaScore(undefined);
    // Retrieve the description from the error and update the error message
    const description = error?.description;
    const newValidationErrors = { ...validationErrors }; // Clone the current errors
    console.log('validations==>', validations);
    const emptyCart = (msg: string, cartCategory: string, errorObj?: any) => navigate(`/${locale}/software/cart/empty`, { state: { msg, cartCategory, error: errorObj } });
    hideLoader();
    setLocalLoader(false);
    if (error?.code === "ENTITLEMENT_VALIDATION_FAILED") {
      setErrorCode(error?.code);
      setErrorMessage(description);
    } else if (error?.code === 'inventory-unavailable-error') {
      hideCartLoader();
      emptyCart(description, error);
    } else if (error?.code === 'CART_PAYMENT_FAILURE') {
      hideCartLoader();
      newValidationErrors['paymentErr'] = t('CART_PAYMENT_FAILURE');
      setErrorMessage(t('CART_PAYMENT_FAILURE'));
    } else if(error?.code === 'invalid-coupon'){
      hideCartLoader();
      emptyCart(description, cartCategory as string, error);
    } else {
      hideCartLoader();
      setShowSubmitOrderErrorModal(true);
      //emptyCart(t('VERIFY_PAGE_ERROR_MESSAGE'));
    }
    // Update validationErrors state with the new error
    setValidationErrors(newValidationErrors);
    setErrorMessage(t(error?.code?.replace(/-/g, '_')?.toUpperCase()));
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const placeOrder = async () => {
    showLoader();
    console.log('reCaptchaToken===>', reCaptchaToken);
    const token = captchaRef.current?.getValue();
    console.log('captchaToken===>', token);
    try {
      await getPaymentIntent({ request_uuid: deviceFingerprintUuid || '' }, handlePaymentIntentSuccess, handleOrderError);

    } catch (error) {
      console.log('CATCH')
      hideLoader();
      console.error(error);
      return null; // Return null in case of an error
    }
  }

  const fetchData = async () => {
    showLoader();
    try {
      const response = await getCart(handleSuccess, handleError);
      // Access the recaptchaValue directly
      hideLoader();
      hideBodyLoader();
      return response; // Return the fetched data
    } catch (error) {
      hideLoader();
      console.error(error);
      return null; // Return null in case of an error
    }
  };

  // Monitor page visibility to detect when page becomes active again
  useEffect(() => {
    const handleVisibilityChange = () => {
      // When page becomes visible again, check if token is expired (logged-in checkout only)
      if (!document.hidden && isLoggedIn && cartData?.idt) {
        if (isJwtTokenExpired(cartData.idt)) {
          console.warn("JWT token (idt) is expired after page became active. Refreshing page to reinitialize.");
          window.location.reload();
        }
      }
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup listener on unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.idt, isGuest, locale]);

  useEffect(() => {
    // Stale idt after logout can remain on guest carts; only reload for logged-in checkout
    if (isLoggedIn && cartData?.idt && isJwtTokenExpired(cartData.idt)) {
      console.warn("JWT token (idt) is expired. Refreshing page to reinitialize.");
      window.location.reload();
      return;
    }
    if (cartData?.totalItemsInCart) {
      if (isGuest && !guestAccessToken) {
        return;
      }

      const decodedIdToken = cartData.idt && isLoggedIn
        ? jwtDecode<{ nid?: string }>(cartData.idt)
        : null;
      const ncaId = decodedIdToken?.nid;

      const initOptions = buildUcpOptions({
        isGuest,
        guestToken: guestAccessToken,
        registeredToken: cartData.idt,
        ncaId,
        base: {
          environment: getUcpEnvironment(),
          theme: "light" as Theme,
          nonce: uuidv4(),
          locale: localeWith_,
          currency: defaultCurrency.toLowerCase(),
          clientFlavor: "public",
          version: "v1",
          clientId: "nvstore",
          enableDeviceFingerprint: true,
        },
      });
      const pending: {
        fingerprintFallbackTimer: number | undefined;
        removeUcpListeners: (() => void) | undefined;
      } = {
        fingerprintFallbackTimer: undefined,
        removeUcpListeners: undefined,
      };
      let cancelled = false;
      if (isGuest) {
        setGuestUcpReady(false);
        setEnablePlaceOrder(false);
      }

      initialize(initOptions)
        .then(() => {
          if (cancelled) {
            return;
          }
          setGuestUcpInitializationError(false);
          if (isGuest) {
            setGuestUcpReady(true);
          }

          const clearFingerprintFallback = () => {
            if (pending.fingerprintFallbackTimer !== undefined) {
              clearTimeout(pending.fingerprintFallbackTimer);
              pending.fingerprintFallbackTimer = undefined;
            }
          };

          const handleGlobalEvent = (event: Event) => {
            if (isGuest) {
              handleUcpGlobalEvent(event);
            }
            const customEvent = event as CustomEvent<{
              message: string;
              metadata: { requestUuid: string };
            }>;
            if (customEvent.detail?.message === 'DEVICE_FINGERPRINT_REQUEST_UUID') {
              clearFingerprintFallback();
              const requestUuid = customEvent.detail.metadata.requestUuid;
              setDeviceFingerprintUuid(requestUuid);
              setEnablePlaceOrder(true);
            }
          };

          const handleFinalizePayment = (event: any) => {
            console.log('Finalize payment event:', event.detail.message);
            setPaymentIntent(null);
            switch (event.detail.message) {
              case 'CONFIRM_PAYMENT_SUCCESS':
              case 'CONFIRM_PAYMENT_ALREADY_SUCCEEDED_REDIRECT':
                submitOrder(handleOrderSuccess, handleOrderError, true);
                showLoader();
                break;
              case 'ALERT':
                submitOrder(handleOrderSuccess, handleOrderError, false, event?.detail);
                showLoader();
                break;
            }
          };
          const events = window.Ucp?.events;
          events?.addEventListener('event-global', handleGlobalEvent);
          events?.addEventListener('event-finalize-payment', handleFinalizePayment);

          pending.removeUcpListeners = () => {
            events?.removeEventListener('event-global', handleGlobalEvent);
            events?.removeEventListener('event-finalize-payment', handleFinalizePayment);
          };

          pending.fingerprintFallbackTimer = window.setTimeout(() => {
            pending.fingerprintFallbackTimer = undefined;
            setEnablePlaceOrder(true);
          }, 5000);
        })
        .catch(() => {
          if (!cancelled && isGuest) {
            setGuestUcpInitializationError(true);
            setGuestUcpReady(false);
            setEnablePlaceOrder(false);
          }
        });
      return () => {
        cancelled = true;
        if (pending.fingerprintFallbackTimer !== undefined) {
          clearTimeout(pending.fingerprintFallbackTimer);
        }
        pending.removeUcpListeners?.();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, localeWith_, defaultCurrency, guestAccessToken, handleUcpGlobalEvent, isGuest]);

  useEffect(() => {
    if (guestTokenError) {
      setEnablePlaceOrder(false);
    }
  }, [guestTokenError]);


  useEffect(() => {
    const getCartData = async () => {
      const response = await fetchData();
      if (response) {
        setCartData(response);
        hideLoader();
        hideBodyLoader();
      }
    };
    if (!cartData) {
      if (userType === 'guest') {
        getCartData();
      } else if (userType === 'loggedIn') {
        setLoginStatus(true);
        getCartData();
      } else {
        navigate(`/${locale}/software/cart/`);
      }
    } else {
      let infoNameBilling = (cartData.billingAddress?.firstName || '') + ' ' + (cartData.billingAddress?.lastName || '');
      let addressBilling =
        (cartData.billingAddress?.line1 ? cartData.billingAddress?.line1 + ', ' : '') +
        (cartData.billingAddress?.line2 ? cartData.billingAddress?.line2 + ', ' : '') +
        (cartData.billingAddress?.city ? cartData.billingAddress?.city + ', ' : '') +
        (cartData.billingAddress?.countrySubdivision && locale !== 'zh-tw' ? cartData.billingAddress?.countrySubdivision + ', ' : '') +
        ((locale !== 'en-hk' && locale !== 'en-me') ? cartData.billingAddress?.postalCode : '');

      if (locale === 'ja-jp') {
        infoNameBilling = (cartData.billingAddress?.lastName || '') + ' ' + (cartData.billingAddress?.firstName || '');
        addressBilling =
          (cartData.billingAddress?.postalCode + ' ' || '') +
          (cartData.billingAddress?.countrySubdivision ? cartData.billingAddress?.countrySubdivision + ', ' : '') +
          (cartData.billingAddress?.city ? cartData.billingAddress?.city + ', ' : '') +
          (cartData.billingAddress?.line1 ? cartData.billingAddress?.line1 : '') +
          (cartData.billingAddress?.line2 ? ', ' + cartData.billingAddress?.line2 : '');
      }
      const items = cartData?.cartItems.cartItem.map((cartItem) => ({
        quantity: cartItem.quantity,
        price: {
          basePrice: parseFloat(String(cartItem?.pricing?.formattedListPrice ?? '').replace(/[^\d.]/g, '')) || 0, // Convert to number
          discount: 0, // Assuming no discount information is present
        },
        productInfo: {
          sku: `sku-${cartItem.product.id}`, // Generate SKU from product ID if no SKU exists
          prodID: cartItem.product.id.toString(),
          productName: cartItem.product.name,
        },
      }));
      const formattedLocale = locale.replace('-', '_').toLowerCase().replace(/^[a-z]{2}/, match => match.toUpperCase());
      const cart = {
        customerID: "",
        orderID: cartData ? cartData['cartId'] : '',
        currencyCode: cartData ? cartData['pricing']['orderTotal']['currency'] : '',
        loginState: isLoggedIn ? 'loggedIn' : 'guest',
        storeLocale: formattedLocale,
        promoCode: "no",
        saveCardOption: false, // Assuming this is a boolean
        items: items
      }
      if (typeof window !== "undefined") {
        (window as any).CartOrder = cart;
      }
      console.log((window as any).CartOrder);
      setbillingInfoName(infoNameBilling);
      setbillingAddress(addressBilling);
      setbillingInfoEmail(cartData.billingAddress?.emailAddress || '');
      setbillingCountry(cartData.billingAddress?.country === COUNTRY_CODE_JP ? COUNTRY_CODE_LOCAL_JP : cartData.billingAddress?.country === COUNTRY_CODE_TW ? COUNTRY_CODE_LOCAL_TW : cartData.billingAddress?.country === COUNTRY_CODE_ME ? COUNTRY_CODE_LOCAL_ME : cartData.billingAddress?.country || '');
      setbillingContact(locale === 'zh-tw' ? sanitizePhoneNo(cartData.billingAddress?.phoneNumber) : formatPhoneNoInReadableForm(sanitizePhoneNo(cartData.billingAddress?.phoneNumber), locale));
    }
    let txt = (cartData?.isDigital) ? t('CONFIRM_DISCLAIMER_DIGITAL') : t('CONFIRM_DISCLAIMER');
    setDisclaimerText(txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]);
  const billingCompanyName = cartData ? resolveCompanyNameFromCart(cartData) : '';
  return (
    <div className="Verify">
      {isLoading}
      {isLoading ? (
        <Spinner />
      ) : (
          <>
            {localLoader && <Spinner />}
        <Container className="verifyWrapper" role="main" aria-labelledby="verify-page-heading">
          <Row xs={'auto'} md={'auto'}>
                <Col md={6} sm={'auto'} className="w100">
              <div id="ShopperInformation" role="region" aria-labelledby="shopper-information-heading">
                <h3 id="shopper-information-heading" className="visually-hidden">{t('SHOPPER_INFORMATION')}</h3>
                <span className={`${(errorCode === 'internal-payment-error' ||
                  errorCode === 'ENTITLEMENT_VALIDATION_FAILED') ? "is-invalid" : ""}`} />
                <Form.Control.Feedback type="invalid" aria-live="assertive">{errorMessage}</Form.Control.Feedback>
                <h2 id="verify-page-heading" className="pageHeading">{t('BTN_REVIEW_ORDER')}</h2>
                <Card id="ShoppingCartMobile">
                  <div className={isCartLoading ? `cart-loading` : ''}>
                    {isCartLoading && <Image src={cartLoader} className="cartLoader" alt={t('CART_LOADING')} aria-live="polite"></Image>}
                    {cartData && (
                      <Cart onCartChange={handleCartChange} validationErrors={validations} onPromoChange={handleCouponChange} onPromoSubmit={handleCouponSubmit} onPromoDelete={handleCouponDelete} isThanks={isThanks} isDownload={isDownload} isVerify={isVerify} cartData={cartData} promoCodeError={false} conflicts={[]} />
                    )}
                  </div>
                </Card>
                {cartData && (<Row xs={'auto'} md={'auto'} className="heightInherit">
                  {isGuest && (<Col md={12}>
                    <div id="contactInfo" className="dr_confirmElement" role="region" aria-labelledby="contact-info-heading">
                      <h3 id="contact-info-heading">{t('DR_CONTACT_INFORMATION_PAGE_TITLE')}</h3>
                      <address>
                        <span>{billingInfoEmail}</span>
                      </address>
                      <button
                        type="button"
                        onClick={handleCartChange}
                        className="continue editButton"
                        aria-label={`${t('BTN_EDIT_CAPS')} ${t('DR_CONTACT_INFORMATION_PAGE_TITLE')}`}
                      >
                        {t('BTN_EDIT_CAPS')}
                      </button>
                    </div>
                  </Col>)}
                  <Col md={6}>
                    <div className="billingInfo mb-4" role="region" aria-labelledby="billing-info-heading">
                      <h3 id="billing-info-heading" className="billingInfo">{t('BILLING_INFORMATION')}</h3>
                      <address>
                        <span className={`${errorCode === 'invalid-bill-to-country' ? "is-invalid" : ""}`}>
                          <p className="billingInfoName">
                            {billingInfoName}
                          </p>
                              {billingCompanyName && (
                                <p className="billingCompany">{billingCompanyName}</p>
                              )}
                          <p className="billingAddress">
                            {billingAddress}
                          </p>
                          <p className="billingCountry">{billingCountry}</p>
                          <span className="billingContact">{billingContact}</span>
                        </span>
                        <Form.Control.Feedback type="invalid" aria-live="assertive">{errorMessage}</Form.Control.Feedback>
                      </address>
                      <button
                        type="button"
                        onClick={handleCartChange}
                        className="continue editButton"
                        aria-label={`${t('BTN_EDIT_CAPS')} ${t('BILLING_INFORMATION')}`}
                      >
                        {t('BTN_EDIT_CAPS')}
                      </button>
                      </div>
                        {
                          billingCompanyName && cartData.taxExemption?.vatNo && (
                            <div className="vatExemptionInfo mb-4" role="region" aria-labelledby="vat-exemption-heading">
                              <h3 id="vat-exemption-heading" className="vatExemption">{t('VAT_EXEMPTION')}</h3>
                              <address>
                                <span>
                                  <p className="vatNo">{cartData.taxExemption.vatNo}</p>
                                </span>
                              </address>
                              <button
                                type="button"
                                onClick={handleCartChange}
                                className="continue editButton"
                                aria-label={`${t('BTN_EDIT_CAPS')} ${t('VAT_EXEMPTION')}`}
                              >
                                {t('BTN_EDIT_CAPS')}
                              </button>
                            </div>
                          )}
                  </Col>
                  {cartData && !cartData?.zdt && <Col md={6}>
                    <div className="paymentInfo mb-4" role="region" aria-labelledby="payment-info-heading">
                      <h3 id="payment-info-heading" className="paymentInfo">{t('PAYMENT_METHOD')}</h3>
                      <address>
                            <span className={`${errorCode === 'CART_PAYMENT_FAILURE' ? "is-invalid" : ""}`}>
                              {
                                isLoggedIn ? (
                                  <cart-selected-payment-method {...paymentConfigAttr} />
                                ) : (
                                  <guest-selected-payment-method {...paymentConfigAttr} />
                                )

                          }
                            </span>

                            <Form.Control.Feedback type="invalid" aria-live="assertive">{errorMessage}</Form.Control.Feedback>
                      </address>
                      <button
                        type="button"
                        onClick={handleCartChange}
                        className="continue"
                        aria-label={`${t('BTN_EDIT_CAPS')} ${t('PAYMENT_METHOD')}`}
                      >
                        {t('BTN_EDIT_CAPS')}
                      </button>
                    </div>
                      </Col>}
                      {paymentIntent && (
                        <Col md={12} key={paymentIntent}>
                          <finalize-payment
                            payment-intent={paymentIntent}
                            return-url={`${window.location.origin}/${locale}/software/cart/verify/?payment-intent-id=${paymentIntent}`}
                          ></finalize-payment>
                        </Col>
                      )}
                  <Col md={12} className="orderDisclaimer mb-4" role="region" aria-labelledby="disclaimer-heading">
                    <h4 id="disclaimer-heading" className="visually-hidden">{t('ORDER_DISCLAIMER')}</h4>
                    <div className="dr_label" role="contentinfo" aria-label={sanitizedText || t('ORDER_DISCLAIMER')}>
                      <span
                        dangerouslySetInnerHTML={{ __html: sanitizedText || '' }}
                        aria-describedby="disclaimer-heading"
                      />
                    </div>
                  </Col>
                  {(isGuest || isDownload) && (
                    <Col md={{ span: 8, offset: 4 }} className="p-0">
                      <div className="captchaWrapper" role="region" aria-labelledby="captcha-heading">
                        <h4 id="captcha-heading" className="visually-hidden">
                          {t('SECURITY_VERIFICATION')}
                        </h4>

                        {/* Wrap reCAPTCHA in a div with aria-labelledby to provide accessible label */}
                        <div role="group" aria-labelledby="captcha-heading">
                          <ReCAPTCHA
                            ref={captchaRef}
                            sitekey={googleKey}
                            size="normal"
                            hl={captchaLanguage}
                            onChange={(value) => handleRecaptcha(value)}
                            onExpired={handleCaptchaTimeout}
                          />
                        </div>
                      </div>
                    </Col>

                  )}
                    <Col md={12} sm={12} className="w100 orderReviewCTA d-flex align-items-center">
                      <div className="flex-grow-1 d-flex">
                        <Button
                          style={{ textTransform: 'capitalize' }}
                          className="continue"
                        onClick={() => window.location.href = config.academyURL}
                        aria-label={t("BTN_CONTINUE_SHOPPING")}
                      >
                        {t("BTN_CONTINUE_SHOPPING")}
                      </Button>
                      </div>
                      <Button
                        type="button"
                      variant="success"
                      className="btn-green submitOrder"
                      id="orderOmniClick"
                      data-product-id=""
                      onClick={placeOrder}
                          disabled={isDisable || !enablePlaceOrder || guestPaymentUnavailable}
                      aria-label={t('BTN_PLACE_ORDER')}
                      aria-describedby={isDisable ? "order-disabled-reason" : undefined}
                    >
                      {t('BTN_PLACE_ORDER')}
                    </Button>
                    {isDisable && (
                      <div id="order-disabled-reason" className="visually-hidden" aria-live="polite">
                        {t('ORDER_BUTTON_DISABLED')}
                      </div>
                    )}
                  </Col>
                </Row>)}
              </div>
            </Col>
            <Col md={{ span: 5, offset: 1 }} role="complementary" aria-labelledby="order-summary-heading">
              <Card id="ShoppingCart" className="reviewOrder">
                <h3 id="order-summary-heading" className="visually-hidden">{t('ORDER_SUMMARY')}</h3>
                {cartData && (
                  <Cart onCartChange={handleCartChange}
                    validationErrors={validations}
                    onPromoChange={handleCouponChange}
                    onPromoSubmit={handleCouponSubmit}
                    onPromoDelete={handleCouponDelete}
                    isDownload={isDownload}
                    isVerify={isVerify}
                    isThanks={isThanks}
                    cartData={cartData}
                    promoCodeError={false}
                    conflicts={[]}
                  />
                )}
              </Card>
            </Col>
          </Row>
            <ErrorModal
              show={showSubmitOrderErrorModal}
              onHide={() => setShowSubmitOrderErrorModal(false)}
            />
            </Container>
          </>
      )}
    </div>
  );
};
export default Verify;